/** GrabX `fea` value: enable Email channel on Chope campaign create */
export const CRM_CHOPE_CREATE_EMAIL_MESSAGE = 'CRMChopeCreateEmailMessage';
export const ENABLE_ROLLOUT_CRM_NEW_FEATURE = 'enableRolloutCrmNewFeature';
/** GrabX `fea` value: enable mobile WebView cookie-token auth */
export const GRAB_CRM_MOBILE_COOKIE_TOKEN_AUTH = 'GrabCRMMobileCookieTokenAuth';
/** GrabX `fea` value: enable auto-campaign for Grab CRM */
export const GRAB_CRM_AUTO_CAMPAIGN = 'GrabCRMAutoCampaign';
/** GrabX feature name for Chope CRM rollout */
export const CHOPE_CRM_FEATURE_NAME = 'enableChopeCRM';
/** GrabX feature name for CRM VN Phase 1 rollout (FE gates on this + country === 'VN') */
export const CRM_VN_PHASE1_FEATURE_NAME = 'enableCRMInVNPhase1';
/** VN Phase-1 contact form for campaign creation (placeholder — PM must confirm before VN flag rollout) */
export const VN_CONTACT_FORM_URL = 'https://www.grab.com/vn/enquire-about-grab-omnicommerce-services/';
export const CHOPE_CRM_PERFORMANCE_REPORTING = 'ChopeCRMPerformanceReporting';
/** GrabX feature flag for automated campaigns */
export const CHOPE_CRM_AUTOMATED_CAMPAIGNS = 'ChopeCRMAutomatedCampaigns';
/** GrabX feature flag for editing Chope campaigns */
export const CHOPE_CRM_EDIT_CAMPAIGN = 'ChopeCRMEditCampaign';

const GRABX_STG_URL = 'https://experiments.stg-myteksi.com/t/variables';

const grabXUrl = (variableName: string) => `${GRABX_STG_URL}/${variableName}/rollout?env=stg`;

export const FEATURE_FLAGS = [
  { key: CHOPE_CRM_FEATURE_NAME, label: 'Chope CRM', grabXUrl: grabXUrl(CHOPE_CRM_FEATURE_NAME) },
  { key: CRM_VN_PHASE1_FEATURE_NAME, label: 'CRM VN Phase 1', grabXUrl: grabXUrl(CRM_VN_PHASE1_FEATURE_NAME) },
  {
    key: `${ENABLE_ROLLOUT_CRM_NEW_FEATURE}:${CHOPE_CRM_PERFORMANCE_REPORTING}`,
    label: 'Chope Performance Reporting',
    grabXUrl: grabXUrl(ENABLE_ROLLOUT_CRM_NEW_FEATURE),
  },
  {
    key: `${ENABLE_ROLLOUT_CRM_NEW_FEATURE}:${CHOPE_CRM_AUTOMATED_CAMPAIGNS}`,
    label: 'Chope Automated Campaigns',
    grabXUrl: grabXUrl(ENABLE_ROLLOUT_CRM_NEW_FEATURE),
  },
  {
    key: `${ENABLE_ROLLOUT_CRM_NEW_FEATURE}:${CHOPE_CRM_EDIT_CAMPAIGN}`,
    label: 'Chope Edit Campaign',
    grabXUrl: grabXUrl(ENABLE_ROLLOUT_CRM_NEW_FEATURE),
  },
  {
    key: `${ENABLE_ROLLOUT_CRM_NEW_FEATURE}:${CRM_CHOPE_CREATE_EMAIL_MESSAGE}`,
    label: 'Chope Create Email Message',
    grabXUrl: grabXUrl(ENABLE_ROLLOUT_CRM_NEW_FEATURE),
  },
  {
    key: `${ENABLE_ROLLOUT_CRM_NEW_FEATURE}:${GRAB_CRM_AUTO_CAMPAIGN}`,
    label: 'Grab CRM Auto Campaign',
    grabXUrl: grabXUrl(ENABLE_ROLLOUT_CRM_NEW_FEATURE),
  },
];
